import React from 'react';
import _, { isObject } from 'lodash';
import {
  Box,
  Card,
  CardHeader,
  CardContent,
  Divider,
  Stack,
  Typography,
  IconButton,
  TextField,
  Select,
  MenuItem,
  Button
} from '@mui/material';
import { Add, Remove } from '@mui/icons-material';

export const DynamicMultiFieldCard = ({
  formik,
  title = 'Dodatkowe informacje',
  fields = [],
  inline
}) => (
  inline ? <>
    {fields.map(config => (
      <DynamicFieldList key={config.field} formik={formik} {...config} inline />
    ))}
  </>
    : <Card sx={{ p: 2, boxShadow: 3, borderRadius: 2, flex: '1 1 50%' }}>
      <CardHeader title={title} sx={{ pb: 1 }} />
      <CardContent>
        <Stack flexDirection="row" flexWrap="wrap">
          {fields.map(config => (
            <DynamicFieldList key={config.field} formik={formik} {...config} />
          ))}
        </Stack>
      </CardContent>
    </Card>
);

const DynamicFieldList = ({
  formik,
  label,
  field,
  options,
  keyName,
  secondKeyName,
  thirdKeyName,
  inline
}) => {
  const handleAddItem = () => {
    const newItem = {
      [keyName]: '',
      [secondKeyName]: 1,
      ...(thirdKeyName ? { [thirdKeyName]: '' } : {})
    };

    formik.setFieldValue(field, [
      ...(formik.values[field] || []),
      newItem
    ]);
  };

  const handleRemoveItem = index => {
    const newArray = [...formik.values[field]];
    newArray.splice(index, 1);
    formik.setFieldValue(field, newArray);
  };

  const isOptionDisabled = optValue => formik.values[field]?.some(item => item[keyName] === optValue);

  return (
    inline ? <Stack direction="row" alignItems="center" justifyContent="center" spacing={1}>
      <Typography variant="subtitle2" flex="1 1 30%">{label}</Typography>
      <Stack direction="column" spacing={1} flex="1 1 60%">
        {/* Jak pojawią się nowe typy to najlepiej dać już props z typem */}
        {formik.values[field] && Array.isArray(formik.values[field]) && formik.values[field]?.map((item, index) => (
          <Stack key={index} direction="row" spacing={2} alignItems="center">
            {options ? <Select
              sx={{ width: 300 }}
              value={item[keyName] || ''}
              onChange={e => {
                const newArray = _.cloneDeep(formik.values[field]);
                newArray[index][keyName] = e.target.value;
                formik.setFieldValue(field, newArray);
              }}
            >
              {options.map(opt => (
                <MenuItem key={opt.value} value={opt.value} disabled={isOptionDisabled(opt.value)}>
                  {opt.label}
                </MenuItem>
              ))}
            </Select> : <TextField
              value={item[keyName]}
              onChange={e => {
                const newArray = _.cloneDeep(formik.values[field]);
                newArray[index][keyName] = e.target.value;
                formik.setFieldValue(field, newArray);
              }}
              inputProps={{ min: 1 }}
              multiline

              sx={{ width: 300 }}
            />}

            <TextField
              type="number"
              value={item[secondKeyName]}
              onChange={e => {
                const newArray = _.cloneDeep(formik.values[field]);
                newArray[index][secondKeyName] = Number(e.target.value);
                formik.setFieldValue(field, newArray);
              }}
              inputProps={{ min: 1 }}
              sx={{ width: 150 }}
              placeholder={secondKeyName}
            />

            {/* thirdKeyName */}
            {thirdKeyName && (
              <TextField
                value={item[thirdKeyName]}
                onChange={e => {
                  const newArray = _.cloneDeep(formik.values[field]);
                  newArray[index][thirdKeyName] = e.target.value;
                  formik.setFieldValue(field, newArray);
                }}
                sx={{ width: 200 }}
                placeholder={thirdKeyName}
              />
            )}

            <IconButton onClick={() => handleRemoveItem(index)} color="error">
              <Remove />
            </IconButton>
          </Stack>
        ))}
      </Stack>
      <Stack >
        <Button
          onClick={handleAddItem}
          startIcon={<Add />}
          variant="text"
          sx={{ alignSelf: 'flex-start' }}
        >
        </Button>
      </Stack>
    </Stack>
      : <Stack spacing={4} ml={4}>
        <Typography variant="h6" fontWeight={600}>{label}</Typography>
        <Divider />
        <Stack direction="row" spacing={2} alignItems="center">
          <Typography variant="button" width={300}>{keyName}</Typography>
          <Typography variant="button" width={200} >{secondKeyName}</Typography>
          {thirdKeyName && <Typography variant="button" width={200}>{thirdKeyName}</Typography>}
        </Stack>
        {/* Jak pojawią się nowe typy to najlepiej dać już props z typem */}
        {formik.values[field] && Array.isArray(formik.values[field]) && formik.values[field]?.map((item, index) => (
          <Stack key={index} direction="row" spacing={2} alignItems="center">
            {/* keyName */}
            {options ? (
              <Select
                sx={{ width: 300 }}
                value={item[keyName] || ''}
                onChange={e => {
                  const newArray = _.cloneDeep(formik.values[field]);
                  newArray[index][keyName] = e.target.value;
                  formik.setFieldValue(field, newArray);
                }}
              >
                {options.map(opt => (
                  <MenuItem key={opt.value} value={opt.value} disabled={isOptionDisabled(opt.value)}>
                    {opt.label}
                  </MenuItem>
                ))}
              </Select>
            ) : (
              <TextField
                value={item[keyName]}
                onChange={e => {
                  const newArray = _.cloneDeep(formik.values[field]);
                  newArray[index][keyName] = e.target.value;
                  formik.setFieldValue(field, newArray);
                }}
                inputProps={{ min: 1 }}
                multiline
                sx={{ width: 300 }}
              />
            )}

            {/* secondKeyName */}
            <TextField
              type="number"
              value={item[secondKeyName]}
              onChange={e => {
                const newArray = _.cloneDeep(formik.values[field]);
                newArray[index][secondKeyName] = Number(e.target.value);
                formik.setFieldValue(field, newArray);
              }}
              inputProps={{ min: 1 }}
              sx={{ width: 200 }}
            />

            {/* thirdKeyName */}
            {thirdKeyName && (
              <TextField
                value={item[thirdKeyName]}
                onChange={e => {
                  const newArray = _.cloneDeep(formik.values[field]);
                  newArray[index][thirdKeyName] = e.target.value;
                  formik.setFieldValue(field, newArray);
                }}
                sx={{ width: 200 }}
              />
            )}

            {/* Remove */}
            <IconButton onClick={() => handleRemoveItem(index)} color="error">
              <Remove />
            </IconButton>
          </Stack>

        ))}

        <Button
          onClick={handleAddItem}
          startIcon={<Add />}
          variant="contained"
          sx={{ alignSelf: 'flex-start' }}
        >
        Dodaj {keyName.toLowerCase()}
        </Button>
      </Stack>
  );
};
